import { findKeyByEnValue, getTranslationByKey } from "./useText.ts";


/**
 * Translates the given text based on the user's language preference stored in localStorage.
 *
 * @param {string} text - The text to be translated.
 * @param {string} page - The page context for the translation.
 * @returns {string} - The translated text.
 * @example
 * const translatedText = textTranslator("Hello", "HOME");
 * console.log(translatedText); // Outputs the translated text based on the user's language preference.
 * @see useText.ts for translation utility functions.
 */

const textTranslator = (text, page) => {
  const lang = localStorage.getItem("language") || "en";
  try{
    const key = findKeyByEnValue(text, true, page)
    ? findKeyByEnValue(text, true, page)
    : text;
  const TranslatedText = getTranslationByKey(key, lang, page);
  return TranslatedText;
  } catch (error) {
    console.warn(`Translation not found for "${text}" in page "${page}"`);
    return text;
  }
};

export default textTranslator;
